module.exports = __webpack_public_path__ + "img/bg.654992f9.jpg";